import React, { FunctionComponent } from "react";
import { LoaderView } from "./styles";

const Loading: FunctionComponent = () => (
    <LoaderView>
        <div className="flat" />
        <div className="flat" />
        <div className="flat" />
        <div className="flat" />
        <div className="flat" />
        <div className="flat" />
        <div className="flat" />
        <div className="flat" />
    </LoaderView>
);

export default Loading;
